import styled, { css } from "styled-components";
import { responsiveMap } from "../../../Grid/_utils/responsiveObserve";

export const _LandingInnovationAdrienCachotRoot = styled("section")<{
  $bg?: {
    desktop?: string;
    mobile?: string;
  };
}>(() => {
  return css`
    padding: 56px 46px;
    position: relative;

    @media ${responsiveMap.mobile} {
      padding: 0px;
    }
  `;
});

export const _LandingInnovationAdrienCachotProductList = styled("div")(() => {
  return css`
    width: 100%;

    .innovation-adrien-cachot-product-item {
      width: 100%;

      @media ${responsiveMap.mobile} {
        border-radius: 8px;
      }
    }
  `;
});

// Desktop: même grid que Umami
export const InnovationProductListWrapper = styled.div`
  @media ${responsiveMap.mobile} {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  @media ${responsiveMap.lg} {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    row-gap: 16px;
    column-gap: 16px;
    width: 100%;
  }
`;

export const InnovationProductItem = styled.div(() => {
  return css`
    @media ${responsiveMap.mobile} {
    }
  `;
});

/** Offset sticky mobile (px) — aligné avec MOBILE_STICKY_TOP dans MobileListAdrienCachot */
const MOBILE_STICKY_TOP_PX = 128;
const MOBILE_CARD_GAP_PX = 16;

/**
 * Section scroll : hauteur minimale pour que le sticky tienne assez longtemps pour que
 * l’élément suivant (z-index plus élevé) monte et masque la carte du dessous.
 * Sans assez de hauteur, le sticky « lâche » avant la fin du chevauchement.
 */
export const StickyCardSection = styled.div<{ $isLast: boolean }>`
  position: sticky;
  top: ${MOBILE_STICKY_TOP_PX}px;
`;

// Mobile : sticky natif + scrub GSAP sur scale/opacity — will-change géré dynamiquement par GSAP (force3D) pour éviter la promotion de toutes les couches dès le départ
export const CardStickyWrapper = styled.div<{ $zIndex: number }>`
  z-index: ${({ $zIndex }) => $zIndex};
  position: sticky;
  top: ${MOBILE_STICKY_TOP_PX}px;
  transform-origin: center center;
`;
